import { api } from '@/lib/api';

export const dashboardService = {
  async getStats() {
    const { data } = await api.get('/dashboard/stats');
    return { data };
  },

  async getPatientInflow() {
    const { data } = await api.get('/dashboard/patient-inflow');
    return { data };
  },

  async getRevenueTrend() {
    const { data } = await api.get('/dashboard/revenue-trend');
    return { data };
  },

  async getActivities() {
    const { data } = await api.get('/dashboard/activities');
    return { data };
  },
};
